import jwtAxios from "@richbeauty/services/auth/jwt-auth/jwt-api";
import { URL_API } from "@richbeauty/services/endpoint";

export const downloadCustomerLeadsTemplate = async () => {
  const config = {
    headers: { "Content-Type": "blob" },
    responseType: "blob",
  };
  return jwtAxios.get(URL_API.CMS_CUSTOMER_LEADS.DOWNLOAD_TEMPLATE, config);
};
